export const services = [
  'criminal_case',
  'contract_dispute',
  'family_affairs',
  'debt_dispute',
  'intellectual_property',
  'enterprise_legal',
  'non_litigation',
  'other'
]
